export const prussian = '#2d344b'
export const brown = '#92613a'
export const jungle = '#2a9d8f'
export const peach = '#Fbaa19'
export const gold = '#e9c46a'
export const white = '#ffffff'
export const black = '#000000'
export const mercury = '#e6e6e6'
export const silver = '#d9d9d9'
export const tomato = '#e06c4f'
export const platinum = '#fafafa'
export const platinumDark = '#f2f2f2'
export const textGreenColor = '#258D7C'
export const textBrownColor = '#795548'

const fontFallbacks = 'Arial, Helvetia, sans-serif'
export const ProximaNova = `Proxima Nova, ${fontFallbacks}`
export const ProximaNovaThin = `Proxima Nova Thin, Proxima Nova, ${fontFallbacks}`



// WEBPACK FOOTER //
// ./src/shared/constants/inlineStyles.js